import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { LAYOUT_BOX, LAYOUT_HEADER } from 'config/constants/ui'
import { useGlobalState } from 'src/sites/state'

const LayoutContainer = ({ backgroundColor, children, maxWidth }) => {
   const { theme } = useGlobalState()
   const isBoxGL = theme.tmpGlobalLayout === LAYOUT_BOX
   const isHeaderGL = theme.tmpGlobalLayout === LAYOUT_HEADER
   let componentProps

   if (isBoxGL) {
      componentProps = {
         paddingRight: `
            ${theme.tmpViewportPaddingD}[d]
            ${theme.tmpViewportPaddingE}[e]
            ${theme.tmpViewportPaddingF}[f]
         `
      }
   }

   if (isHeaderGL) {
      componentProps = {
         paddingHorizontal: `
            ${theme.tmpViewportPaddingE}[e]
            ${theme.tmpViewportPaddingF}[f]
         `
      }
   }

   return (
      <View
         display="flex"
         justifyContent="center"
         position="relative"
         width="100%"
         marginTop={theme.viewportMarginTop}
         {...componentProps}>
         <View
            width="100%"
            maxWidth={maxWidth}
            minHeight="100vh"
            backgroundColor={backgroundColor || theme.tmpContentBackgroundColor}>
            {children}
         </View>
      </View>
   )
}

LayoutContainer.propTypes = {
   backgroundColor: PropTypes.string,
   children: PropTypes.node.isRequired,
   maxWidth: PropTypes.string
}

LayoutContainer.defaultProps = {
   backgroundColor: undefined,
   maxWidth: undefined
}

export default LayoutContainer
